export default "__VITE_ASSET__D3C9PF1g__"